import React from "react";

const TitleModal = ({ title, fontSize = "30px", lineHeight = "32px" }) => {
  return (
    <p
      dangerouslySetInnerHTML={{
        __html: title,
      }}
      style={{
        fontSize: fontSize,
        // textTransform: "uppercase",
        fontWeight: "bold",
        overflowWrap: "break-word",
        fontFamily: "Rubik",
        lineHeight: lineHeight,
        color: "#0D0040",
      }}
    />
  );
};

export default TitleModal;
